/*
 * Sign Trade Supplies - Quick Order page (sections/quick-order.liquid).
 *
 * Pricing mirrors Discountly's cart script (assets/ac-tiered-qty-cart.js, customerHasTag +
 * TieredPricingCart + CalculateTier) step for step, including where it rounds, so the price shown
 * here is the price the cart page shows and sends to checkout:
 *   1. Trade+ customers: base price less the store-wide "AllProducts" tier % (20%), rounded to the
 *      penny, unless the product is on that tier's exclude list.
 *   2. Quantity breaks from the product's ACPTiered tiers (served by
 *      templates/product.quick-order-data.liquid, same selection as cart.ac_cart_tiers) are applied
 *      to that price. "products" tiers count every variant of the product in the basket,
 *      "collections" tiers count every product sharing the tier, "variants" tiers count the line.
 * Quantities include what is already in the basket, because that is what the cart page will see.
 * If Discountly's cart script changes, re-check this file against it.
 *
 * Custom size products (Itoris DPO) are priced on Itoris's server and can't be added from here, so
 * they open in their own window; the item Itoris adds to the basket is then shown in the list.
 */
(function () {
  'use strict';

  var root = document.getElementById('sts-quick-order');
  if (!root) return;
  var cfg = JSON.parse(document.getElementById('sts-qo-config').textContent);
  var STORAGE_KEY = 'sts-quick-order:v1';
  var UNIT_LABELS = { 1: 'per m', 2: 'per 50m roll', 3: 'per 30m roll', 4: 'per kit' };

  // ---------------------------------------------------------------- pricing

  function r2(n) { return Number(Number(n).toFixed(2)); }

  function isTradeExcluded(productId) {
    var t = cfg.tradeTier;
    var list = (t && t.excludeProducts) || [];
    return list.some(function (p) { return p.id == 'gid://shopify/Product/' + productId || p.id == productId; });
  }

  // Price in pounds before quantity breaks (cart script: customerHasTag).
  function startPrice(pence, productId) {
    var t = cfg.tradeTier;
    if (!cfg.isTrade) return r2(pence / 100);
    if (isTradeExcluded(productId)) return pence / 100;
    var pct = t && t.status ? Number(t.tier_values[0]) : 0;
    return r2((pence - pence * pct / 100) / 100);
  }

  function tierObject(tiers, variantId) {
    if (!Array.isArray(tiers) || !tiers.length) return null;
    var obj = tiers[0].tier !== undefined ? tiers[0].tier : tiers[0];
    if (obj.entity_type !== 'variants') return obj;
    var i = obj.variant_ids.indexOf(String(variantId));
    if (i === -1) i = obj.variant_ids.indexOf(Number(variantId));
    if (i === -1) return null;
    return {
      entity_type: 'variants',
      discount_type: obj.discount_type[i],
      status: obj.status[i],
      tier_min: obj.tier_min[i],
      tier_max: obj.tier_max[i],
      tier_values: obj.tier_values[i],
      start_date: obj.start_date[i],
      end_date: obj.end_date[i],
      Location_Tag_: obj.Location_Tag_ != null ? obj.Location_Tag_[i] : null,
      DiscountAppliedON: obj.DiscountAppliedON != null ? obj.DiscountAppliedON[i] : null
    };
  }

  function dateValid(start, end) {
    var now = Date.parse(cfg.storeTime);
    return (start == null || now >= Date.parse(start)) && (end == null || now <= Date.parse(end));
  }

  function tierApplies(t) {
    if (!t || !t.status || !dateValid(t.start_date, t.end_date)) return false;
    if (t.DiscountAppliedON == null || t.DiscountAppliedON === '') return true;
    var online = t.DiscountAppliedON === 'Both_Store' || t.DiscountAppliedON === 'Online_Store';
    if (t.Location_Tag_ == null || t.Location_Tag_ === '') return online;
    var key = Object.keys(t.Location_Tag_)[0];
    var locs = t.Location_Tag_[key] || [];
    if (key === 'StoreLocation') return online && (locs.indexOf(cfg.storeCountry) !== -1 || locs.indexOf(cfg.storeCity) !== -1);
    var mine = cfg.customerCountries.concat(cfg.customerCities);
    return online && locs.some(function (l) { return mine.indexOf(l) !== -1; });
  }

  // Price after quantity breaks (cart script: CalculateTier - the last matching band wins).
  function tierPrice(base, t, qty) {
    var price = null;
    for (var i = 0; i < t.tier_min.length; i++) {
      var p = priceAtBand(base, t, i);
      var max = t.tier_max[i] != 'max' ? parseInt(t.tier_max[i], 10) : 'max';
      if (qty >= parseInt(t.tier_min[i], 10) && (max === 'max' || qty <= max)) price = p;
    }
    return price;
  }

  function priceAtBand(base, t, i) {
    var v = parseFloat(t.tier_values[i]);
    var p = base;
    if (t.discount_type === 'percentage') p = r2(r2(base) - r2(v / 100 * r2(base)));
    else if (t.discount_type === 'fixed') p = r2(r2(base) - v);
    else if (t.discount_type === 'fixed_price') p = r2(v);
    return p < 0 ? 0 : p;
  }

  // Everything the cart page would see once the list is added: basket lines plus list lines,
  // merged by variant the same way /cart/add.js merges them.
  function buildPool() {
    var pool = {};
    state.cart.items.forEach(function (item) {
      if (isCalcItem(item)) return;
      var entry = pool[item.variant_id] || (pool[item.variant_id] = { productId: item.product_id, variantId: item.variant_id, qty: 0, inBasket: 0, tiers: state.cartTiers[item.variant_id] || [] });
      entry.qty += item.quantity;
      entry.inBasket += item.quantity;
    });
    state.lines.forEach(function (line) {
      var product = state.products[line.handle];
      if (!product || !line.variantId) return;
      var entry = pool[line.variantId] || (pool[line.variantId] = { productId: product.id, variantId: line.variantId, qty: 0, inBasket: 0, tiers: product.tiers });
      entry.qty += line.qty;
      entry.tiers = product.tiers;
    });
    return Object.keys(pool).map(function (k) { return pool[k]; });
  }

  function sharesTier(t, entry, e) {
    if (t.entity_type === 'products') return e.productId == entry.productId;
    if (t.entity_type === 'collections') {
      var o = Array.isArray(e.tiers) && e.tiers[0];
      return !!o && o.entity_type === 'collections' && o.entity_id == t.entity_id;
    }
    return e === entry;
  }

  function tierQty(t, entry, pool) {
    return pool.filter(function (e) { return sharesTier(t, entry, e); }).reduce(function (s, e) { return s + e.qty; }, 0);
  }

  function priceLine(line, pool) {
    var product = state.products[line.handle];
    var variant = product && findVariant(product, line.variantId);
    if (!variant) return null;
    var listPrice = r2(variant.price / 100);
    var base = startPrice(variant.price, product.id);
    var entry = pool.filter(function (e) { return e.variantId == variant.id; })[0];
    var t = tierObject(product.tiers, variant.id);
    var unit = base, label = '', next = null, countedQty = line.qty;
    if (cfg.isTrade && base !== listPrice) label = 'Trade+';
    if (t && tierApplies(t)) {
      countedQty = tierQty(t, entry, pool);
      var tp = tierPrice(base, t, countedQty);
      if (tp !== null) { unit = tp; label = tierLabel(t, countedQty) || label; }
      next = nextBand(base, t, countedQty);
    }
    return {
      unit: unit,
      list: listPrice,
      total: r2(unit * line.qty),
      label: label,
      next: next,
      inBasket: entry ? entry.inBasket : 0,
      // Other options of this product (or tier collection) already in the basket that count
      // towards this break - their basket price moves too.
      sharedBasket: t && tierApplies(t) ? pool.reduce(function (s, e) {
        return e !== entry && sharesTier(t, entry, e) ? s + e.inBasket : s;
      }, 0) : 0
    };
  }

  function tierLabel(t, qty) {
    for (var i = t.tier_min.length - 1; i >= 0; i--) {
      var max = t.tier_max[i] != 'max' ? parseInt(t.tier_max[i], 10) : 'max';
      if (qty >= parseInt(t.tier_min[i], 10) && (max === 'max' || qty <= max)) {
        return t.discount_type === 'percentage' ? 'Qty break ' + parseFloat(t.tier_values[i]) + '% off' : 'Qty break';
      }
    }
    return '';
  }

  function nextBand(base, t, qty) {
    var best = null;
    for (var i = 0; i < t.tier_min.length; i++) {
      var min = parseInt(t.tier_min[i], 10);
      if (min > qty && (best === null || min < best.min)) best = { min: min, price: priceAtBand(base, t, i), wide: t.entity_type !== 'variants' };
    }
    return best;
  }

  // ---------------------------------------------------------------- state

  var state = {
    lines: [],          // { id, handle, variantId, qty }
    products: {},       // handle -> data from ?view=quick-order-data
    cart: { items: [] },
    cartTiers: {},      // variant id -> tiers, for items already in the basket
    loading: {}
  };
  var lineSeq = 0;

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.lines.map(function (l) {
        return { handle: l.handle, variantId: l.variantId, qty: l.qty };
      })));
    } catch (e) {}
  }

  function restore() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }

  function findVariant(product, id) {
    return product.variants.filter(function (v) { return v.id == id; })[0];
  }

  // ---------------------------------------------------------------- shop data

  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) {}
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Request failed (' + r.status + ')');
        return data;
      });
    });
  }

  function loadProduct(handle) {
    if (state.products[handle]) return Promise.resolve(state.products[handle]);
    if (state.loading[handle]) return state.loading[handle];
    state.loading[handle] = getJSON('/products/' + encodeURIComponent(handle) + '?view=quick-order-data').then(function (p) {
      if (p && typeof p.tiers === 'string') p.tiers = [];
      state.products[handle] = p;
      delete state.loading[handle];
      return p;
    }).catch(function (err) { delete state.loading[handle]; throw err; });
    return state.loading[handle];
  }

  function refreshCart() {
    return getJSON('/cart.js').then(function (cart) {
      state.cart = cart;
      var needTiers = cart.items.some(function (i) { return !isCalcItem(i); });
      if (!needTiers) { state.cartTiers = {}; return; }
      return fetch('/cart?view=ac_cart_tiers').then(function (r) { return r.text(); }).then(function (text) {
        var map = {};
        try {
          JSON.parse(text).forEach(function (row) { map[row.variant_id] = Array.isArray(row.tiers) ? row.tiers : []; });
        } catch (e) {}
        state.cartTiers = map;
      });
    }).then(render, function () { render(); });
  }

  function predictive(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,variants.sku,variants.title,product_type,tag,vendor';
    return getJSON(url).then(function (d) { return (d && d.resources && d.resources.results.products) || []; });
  }

  // ---------------------------------------------------------------- Itoris (custom size) lines

  function isCalcItem(item) {
    var p = item.properties || {};
    return !!(p.__dpo_hash || p._dpo_id || p._pvid || (item.title && item.title.indexOf('(D#') !== -1));
  }

  function calcGroups() {
    var items = state.cart.items.filter(isCalcItem);
    var parents = items.filter(function (i) { return !(i.properties && i.properties._pvid); });
    return parents.map(function (parent) {
      var children = items.filter(function (i) { return i.properties && i.properties._pvid == parent.variant_id; });
      var all = [parent].concat(children);
      var total = all.reduce(function (s, i) { return s + r2(startPrice(i.original_price, i.product_id) * i.quantity); }, 0);
      var listTotal = all.reduce(function (s, i) { return s + i.original_line_price / 100; }, 0);
      return { parent: parent, keys: all.map(function (i) { return i.key; }), total: r2(total), listTotal: r2(listTotal) };
    });
  }

  var calcWatch = null;
  function openCalculator(url) {
    var before = {};
    state.cart.items.forEach(function (i) { before[i.key] = true; });
    var win = window.open(url, 'sts-qo-calculator', 'width=1200,height=900');
    if (!win) {
      showError('Your browser blocked the calculator window. Allow pop-ups for this site, or open it here: ' + url);
      return;
    }
    clearInterval(calcWatch);
    calcWatch = setInterval(function () {
      var closed = false;
      try { closed = win.closed; } catch (e) {}
      getJSON('/cart.js').then(function (cart) {
        var added = cart.items.some(function (i) { return isCalcItem(i) && !before[i.key]; });
        if (added || closed) {
          clearInterval(calcWatch);
          if (added && !closed) { try { win.close(); } catch (e) {} }
          refreshCart();
          if (added) flash('Custom item added to your basket.');
        }
      }).catch(function () {});
    }, 1500);
  }

  function removeCalc(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return getJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(refreshCart, function (err) { showError(err.message); });
  }

  // ---------------------------------------------------------------- list actions

  // Products the section lists as custom size calculators are priced by Itoris even when the
  // variant has a base price (e.g. the Maxiframe kit), so never add those at the bare variant price.
  function isCalculator(p) {
    return p.calculator || cfg.calculatorIds.indexOf(p.id) !== -1;
  }

  // variantId null = the customer still has to choose an option; the line stays out of the
  // totals and blocks "Add all to basket" until they do.
  function addLine(handle, variantId, qty) {
    var existing = variantId && state.lines.filter(function (l) { return l.handle === handle && l.variantId == variantId; })[0];
    if (existing) existing.qty += qty;
    else state.lines.push({ id: ++lineSeq, handle: handle, variantId: variantId, qty: qty });
    save();
    render();
  }

  function skuMatch(product, sku) {
    return product.variants.filter(function (v) { return v.sku && v.sku.toLowerCase() === sku; })[0];
  }

  // From search, a product with options asks which one, unless the search text is the full SKU
  // of one of its options (e.g. RSG76-6000). That shortcut is skipped when another product in the
  // results shares the SKU (e.g. RSC76 is on both the post clips and the pallet-quantity clips).
  function addProduct(handle, query, otherHandles) {
    var sku = (query || '').trim().toLowerCase();
    return loadProduct(handle).then(function (p) {
      if (isCalculator(p)) { openCalculator(p.url); return; }
      if (p.variants.length === 1) return p.variants[0];
      var exact = sku && skuMatch(p, sku);
      if (!exact) return null;
      return Promise.all((otherHandles || []).filter(function (h) { return h !== handle; }).map(function (h) {
        return loadProduct(h).then(function (o) { return !!skuMatch(o, sku); }, function () { return false; });
      })).then(function (shared) { return shared.indexOf(true) === -1 ? exact : null; });
    }).then(function (chosen) {
      if (chosen === undefined) return;
      addLine(handle, chosen ? chosen.id : null, 1);
      var row = root.querySelector('[data-line="' + state.lines[state.lines.length - 1].id + '"]');
      var field = row && row.querySelector(chosen ? 'input[type=number]' : 'select');
      if (field) field.focus();
    }).catch(function (err) { showError(err.message); });
  }

  function findSku(sku) {
    var wanted = sku.toLowerCase();
    return predictive(sku).then(function (results) {
      var chain = Promise.resolve(null);
      results.slice(0, 6).forEach(function (r) {
        chain = chain.then(function (hit) {
          if (hit) return hit;
          return loadProduct(r.handle).then(function (p) {
            var v = p.variants.filter(function (x) { return x.sku && x.sku.toLowerCase() === wanted; })[0];
            return v ? { product: p, variant: v } : null;
          }).catch(function () { return null; });
        });
      });
      return chain;
    });
  }

  function parsePaste(text) {
    return text.split(/\r?\n/).map(function (raw) {
      var parts = raw.trim().split(/[\s,;\t]+/).filter(Boolean);
      if (!parts.length) return null;
      var qty = 1;
      if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) qty = parseInt(parts.pop(), 10);
      return { sku: parts.join(' '), qty: Math.max(1, qty) };
    }).filter(Boolean);
  }

  function addPasted() {
    var box = root.querySelector('#sts-qo-paste');
    var status = root.querySelector('[data-qo-paste-status]');
    var rows = parsePaste(box.value);
    if (!rows.length) return;
    var missing = [], done = 0;
    status.textContent = 'Looking up ' + rows.length + ' item(s)...';
    var chain = Promise.resolve();
    rows.forEach(function (row) {
      chain = chain.then(function () {
        return findSku(row.sku).then(function (hit) {
          if (!hit) { missing.push(row.sku); return; }
          if (isCalculator(hit.product)) { missing.push(row.sku + ' (custom size - use the calculator)'); return; }
          addLine(hit.product.handle, hit.variant.id, row.qty);
          done++;
        });
      });
    });
    chain.then(function () {
      status.textContent = done + ' added.' + (missing.length ? ' Not found: ' + missing.join(', ') : '');
      box.value = missing.length ? rows.filter(function (r) { return missing.some(function (m) { return m.indexOf(r.sku) === 0; }); }).map(function (r) { return r.sku + ', ' + r.qty; }).join('\n') : '';
    });
  }

  function addAllToBasket() {
    var pending = state.lines.filter(function (l) { return !l.variantId && state.products[l.handle]; });
    if (pending.length) {
      showError('Choose an option for: ' + pending.map(function (l) { return state.products[l.handle].title; }).join(', '));
      var select = root.querySelector('[data-line="' + pending[0].id + '"] select');
      if (select) select.focus();
      return;
    }
    var items = state.lines.filter(function (l) { return l.variantId && l.qty > 0 && state.products[l.handle]; })
      .map(function (l) { return { id: l.variantId, quantity: l.qty }; });
    var btn = root.querySelector('[data-qo-add-all]');
    if (!items.length) { window.location.href = '/cart'; return; }
    btn.disabled = true;
    btn.textContent = 'Adding...';
    getJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      state.lines = [];
      save();
      // Discountly only applies quantity/Trade+ discounts from the cart page's checkout button,
      // so always land there rather than going straight to checkout.
      window.location.href = '/cart';
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Add all to basket';
      showError(err.message);
    });
  }

  // ---------------------------------------------------------------- rendering

  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function fmt(n) { return money.format(n); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    var host = root.querySelector('[data-qo-lines]');
    var pool = buildPool();
    var subtotal = 0, html = '';

    calcGroups().forEach(function (g) {
      var p = g.parent;
      subtotal += g.total;
      var props = Object.keys(p.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && p.properties[k]; })
        .slice(0, 6).map(function (k) { return esc(k) + ': ' + esc(p.properties[k]); }).join(' &middot; ');
      html += '<div class="sts-qo__row sts-qo__row--calc">' +
        '<div class="sts-qo__product">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48">' : '') +
          '<div><a href="' + esc(p.url) + '" class="sts-qo__name">' + esc(p.product_title) + '</a>' +
          '<div class="sts-qo__meta"><span class="sts-qo__tag">Custom size - in your basket</span>' + (props ? ' ' + props : '') + '</div></div></div>' +
        '<div class="sts-qo__price" data-label="Unit price">' + priceHtml(r2(g.total / p.quantity), r2(g.listTotal / p.quantity), cfg.isTrade && g.total !== g.listTotal ? 'Trade+' : '') + '</div>' +
        '<div data-label="Qty"><span class="sts-qo__qty-fixed">' + p.quantity + '</span></div>' +
        '<div class="sts-qo__total" data-label="Line total">' + fmt(g.total) + '</div>' +
        '<div><button type="button" class="sts-qo__remove" data-qo-remove-calc="' + esc(g.keys.join('|')) + '" aria-label="Remove from basket">&times;</button></div>' +
        '</div>';
    });

    state.lines.forEach(function (line) {
      var product = state.products[line.handle];
      if (!product) {
        html += '<div class="sts-qo__row" data-line="' + line.id + '"><div class="sts-qo__product"><div><span class="sts-qo__name">Loading...</span></div></div><div></div><div></div><div></div><div></div></div>';
        return;
      }
      var variant = line.variantId ? findVariant(product, line.variantId) : null;
      if (!variant) line.variantId = null;
      var options = product.variants.length > 1 ? '<select data-qo-variant aria-label="Option">' +
        (variant ? '' : '<option value="" selected disabled>Choose an option...</option>') +
        product.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (variant && v.id == variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.sku ? ' (' + esc(v.sku) + ')' : '') + (v.available ? '' : ' - sold out') + '</option>';
        }).join('') + '</select>' : '';
      if (!variant) {
        html += '<div class="sts-qo__row is-pending" data-line="' + line.id + '">' +
          '<div class="sts-qo__product">' + (product.image ? '<img src="' + esc(product.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<div><a href="' + esc(product.url) + '" class="sts-qo__name" target="_blank" rel="noopener">' + esc(product.title) + '</a>' + options + '</div></div>' +
          '<div class="sts-qo__price" data-label="Unit price"><span class="sts-qo__choose">Choose an option</span></div>' +
          '<div data-label="Qty"><div class="sts-qo__qty"><button type="button" data-qo-step="-1" aria-label="Decrease">&minus;</button>' +
            '<input type="number" min="1" step="1" inputmode="numeric" value="' + line.qty + '" aria-label="Quantity"><button type="button" data-qo-step="1" aria-label="Increase">+</button></div></div>' +
          '<div class="sts-qo__total" data-label="Line total">&ndash;</div>' +
          '<div><button type="button" class="sts-qo__remove" data-qo-remove aria-label="Remove">&times;</button></div>' +
          '</div>';
        return;
      }
      var pr = priceLine(line, pool);
      subtotal += pr.total;
      var notes = [];
      if (variant.sku) notes.push('SKU ' + esc(variant.sku));
      if (UNIT_LABELS[product.priceUnit]) notes.push(UNIT_LABELS[product.priceUnit]);
      if (!variant.available) notes.push('<span class="sts-qo__warn">Out of stock</span>');
      if (pr.inBasket) notes.push(pr.inBasket + ' already in basket');
      if (pr.sharedBasket) notes.push('Break also counts ' + pr.sharedBasket + ' of other options in your basket, and lowers their price too');
      html += '<div class="sts-qo__row" data-line="' + line.id + '">' +
        '<div class="sts-qo__product">' + (product.image ? '<img src="' + esc(product.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<div><a href="' + esc(product.url) + '" class="sts-qo__name" target="_blank" rel="noopener">' + esc(product.title) + '</a>' + options +
          '<div class="sts-qo__meta">' + notes.join(' &middot; ') + '</div></div></div>' +
        '<div class="sts-qo__price" data-label="Unit price">' + priceHtml(pr.unit, pr.list, pr.label) +
          (pr.next ? '<div class="sts-qo__next">' + fmt(pr.next.price) + ' each at ' + pr.next.min + '+' + (pr.next.wide ? ' (all options combined)' : '') + '</div>' : '') + '</div>' +
        '<div data-label="Qty"><div class="sts-qo__qty"><button type="button" data-qo-step="-1" aria-label="Decrease">&minus;</button>' +
          '<input type="number" min="1" step="1" inputmode="numeric" value="' + line.qty + '" aria-label="Quantity"><button type="button" data-qo-step="1" aria-label="Increase">+</button></div></div>' +
        '<div class="sts-qo__total" data-label="Line total">' + fmt(pr.total) + '</div>' +
        '<div><button type="button" class="sts-qo__remove" data-qo-remove aria-label="Remove">&times;</button></div>' +
        '</div>';
    });

    host.innerHTML = html;
    var count = state.lines.length + calcGroups().length;
    root.querySelector('[data-qo-empty]').hidden = count > 0;
    root.querySelector('[data-qo-subtotal]').textContent = fmt(r2(subtotal));
    var addBtn = root.querySelector('[data-qo-add-all]');
    addBtn.disabled = count === 0;
    addBtn.textContent = state.lines.length ? 'Add all to basket' : 'Go to basket';
  }

  function priceHtml(unit, list, label) {
    var out = '<strong>' + fmt(unit) + '</strong>';
    if (unit < list) out = '<s>' + fmt(list) + '</s> ' + out;
    if (label) out += '<span class="sts-qo__tag sts-qo__tag--deal">' + esc(label) + '</span>';
    return out;
  }

  function showError(msg) {
    var el = root.querySelector('[data-qo-error]');
    el.textContent = msg;
    el.hidden = !msg;
  }

  var flashTimer = null;
  function flash(msg) {
    var el = root.querySelector('[data-qo-error]');
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('is-ok');
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { el.hidden = true; el.classList.remove('is-ok'); }, 4000);
  }

  // ---------------------------------------------------------------- search box

  var input = root.querySelector('#sts-qo-search');
  var results = root.querySelector('#sts-qo-results');
  var searchTimer = null, searchSeq = 0, active = -1;

  function closeResults() { results.hidden = true; results.innerHTML = ''; active = -1; input.setAttribute('aria-expanded', 'false'); }

  function runSearch() {
    var q = input.value.trim();
    if (q.length < 2) { closeResults(); return; }
    var seq = ++searchSeq;
    predictive(q).then(function (products) {
      if (seq !== searchSeq) return;
      if (!products.length) {
        results.innerHTML = '<li class="sts-qo__result-empty">No products found</li>';
      } else {
        results.innerHTML = products.map(function (p, i) {
          var calc = isCalculator({ id: p.id, calculator: Number(p.price) === 0 });
          return '<li role="option" id="sts-qo-opt-' + i + '" data-handle="' + esc(p.handle) + '">' +
            (p.image ? '<img src="' + esc(p.image) + '&width=80" alt="" width="40" height="40">' : '<span></span>') +
            '<span class="sts-qo__result-title">' + esc(p.title) + '</span>' +
            '<span class="sts-qo__result-price">' + (calc ? 'Custom size' : (p.price_min !== p.price_max ? 'from ' : '') + fmt(Number(p.price_min || p.price))) + '</span></li>';
        }).join('');
      }
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }).catch(function () {});
  }

  function pickResult(li) {
    if (!li || !li.dataset.handle) return;
    var query = input.value;
    var handles = [].map.call(results.querySelectorAll('li[data-handle]'), function (x) { return x.dataset.handle; });
    input.value = '';
    closeResults();
    addProduct(li.dataset.handle, query, handles);
  }

  input.addEventListener('input', function () { clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 200); });
  input.addEventListener('keydown', function (e) {
    var items = results.querySelectorAll('li[data-handle]');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!items.length) return;
      e.preventDefault();
      active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items.forEach(function (li, i) { li.classList.toggle('is-active', i === active); });
      input.setAttribute('aria-activedescendant', items[active].id);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      pickResult(items[active >= 0 ? active : 0]);
    } else if (e.key === 'Escape') {
      closeResults();
    }
  });
  results.addEventListener('mousedown', function (e) { e.preventDefault(); pickResult(e.target.closest('li')); });
  input.addEventListener('blur', function () { setTimeout(closeResults, 150); });

  // ---------------------------------------------------------------- table events

  function lineFor(el) {
    var row = el.closest('[data-line]');
    var id = row && Number(row.dataset.line);
    return state.lines.filter(function (l) { return l.id === id; })[0];
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var step = t.closest('[data-qo-step]');
    if (step) {
      var line = lineFor(step);
      line.qty = Math.max(1, line.qty + Number(step.dataset.qoStep));
      save(); render();
      return;
    }
    if (t.closest('[data-qo-remove]')) {
      var l = lineFor(t);
      state.lines = state.lines.filter(function (x) { return x !== l; });
      save(); render();
      return;
    }
    var calcRemove = t.closest('[data-qo-remove-calc]');
    if (calcRemove) { removeCalc(calcRemove.dataset.qoRemoveCalc.split('|')); return; }
    var calc = t.closest('[data-qo-calc]');
    if (calc) { openCalculator(calc.dataset.qoCalc); return; }
    var feat = t.closest('[data-qo-feat]');
    if (feat) { addProduct(feat.dataset.qoFeat); return; }
    if (t.closest('[data-qo-paste-toggle]')) {
      var box = root.querySelector('[data-qo-paste]');
      box.hidden = !box.hidden;
      if (!box.hidden) root.querySelector('#sts-qo-paste').focus();
      return;
    }
    if (t.closest('[data-qo-paste-add]')) { addPasted(); return; }
    if (t.closest('[data-qo-clear]')) { state.lines = []; save(); render(); return; }
    if (t.closest('[data-qo-add-all]')) { showError(''); addAllToBasket(); }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-qo-variant]')) {
      lineFor(t).variantId = Number(t.value);
      save(); render();
    } else if (t.matches('[data-line] input[type=number]')) {
      lineFor(t).qty = Math.max(1, parseInt(t.value, 10) || 1);
      save(); render();
    }
  });

  window.addEventListener('focus', function () { refreshCart(); });

  // ---------------------------------------------------------------- start

  // Featured product cards: Liquid prints the list "from" price; show what this customer pays
  // before quantity breaks (Trade+ applied the same way as the order lines).
  [].forEach.call(root.querySelectorAll('[data-qo-feat-price]'), function (el) {
    var list = r2(Number(el.dataset.qoFeatPrice) / 100);
    var unit = startPrice(Number(el.dataset.qoFeatPrice), Number(el.dataset.qoFeatId));
    el.innerHTML = (el.dataset.qoFeatVaries === 'true' ? 'From ' : '') + priceHtml(unit, list, '') + ' <span class="sts-qo__vat">+ VAT</span>';
  });

  restore().forEach(function (saved) {
    state.lines.push({ id: ++lineSeq, handle: saved.handle, variantId: saved.variantId, qty: saved.qty || 1 });
  });
  render();
  Promise.all(state.lines.map(function (l) {
    return loadProduct(l.handle).catch(function () {
      state.lines = state.lines.filter(function (x) { return x !== l; });
    });
  })).then(function () { save(); return refreshCart(); });
})();
